import React, {useContext} from "react";
import "./Contact.scss";
import SocialMedia from "../../components/socialMedia/SocialMedia";
import {illustration, contactInfo} from "../../portfolio";
import {Fade} from "react-reveal";
import email from "../../assets/lottie/email";
import DisplayLottie from "../../components/displayLottie/DisplayLottie";
import StyleContext from "../../contexts/StyleContext";

export default function Contact() {
  const {isDark} = useContext(StyleContext);
  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main contact-margin-top" id="contact">
        <div className="contact-div-main">
          <div className="contact-header">
            <h1 className="heading contact-title">{contactInfo.title}</h1>
            <p
              className={
                isDark
                  ? "dark-mode contact-subtitle"
                  : "subTitle contact-subtitle"
              }
            >
              {contactInfo.subtitle}
            </p>
            <div
              className={
                isDark ? "dark-mode contact-text-div" : "contact-text-div"
              }
            >
              {contactInfo.number && (
                <>
                  <a
                    className="contact-detail"
                    href={"tel:" + "+1 617-560-0716"}
                  >
                    {"+1 617-560-0716"}
                  </a>
                  <br />
                  <br />
                </>
              )}
              <a
                className="contact-detail-email"
                href={"mailto:" + "sharma.bhan@northeastern.edu"}
              >
                {"sharma.bhan@northeastern.edu"}
              </a>
              <br />
              <br />
              <SocialMedia />
            </div>
          </div>
          <div className="contact-image-div">
  <img
    alt="Contact Me"
    src={require("../../assets/images/my_image.jpg")} // Add your image to assets/images folder
    style={{ 
      width: '300px',
      height: '300px',
      borderRadius: '50%',  // Makes it circular like GitHub profile pics
      objectFit: 'cover',   // Ensures image fills the circle properly
      display: 'block',
      margin: '0 auto',
      marginRight: '50px'
    }} // Adjust sizing as needed
  />
</div>
        </div>
      </div>
    </Fade>
  );
}
